module.exports = __webpack_public_path__ + "img/2025-03-05-01-02.f091adaf.png";